<template>
  <v-layout row wrap>
    <v-flex
      xs12
      sm6
      md6
      class="pa-2"
      v-for="(item, key) in resources"
      :key="key"
    >
      <Resource :course="item" />
    </v-flex>
    <v-flex xs12 v-if="showTitle">
      <h2 class="subheading grey--text">Sociedades Científicas</h2>
    </v-flex>
    <v-flex
      xs12
      sm6
      md6
      class="pa-2"
      v-for="image in filteredScientificSocieties"
      :key="image.text"
    >
      <imagebox :image="image" />
    </v-flex>
  </v-layout>
</template>

<script>
import imagebox from './Image'
import Resource from './Resource.vue'
import cms from '@/content'
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
  components: {
    imagebox,
    Resource
  },
  data() {
    return {
      imageGroup: cms.getlogotypes(),
      resources: []
    }
  },
  created() {
    axios.get(`/xerpa-learn/resources/${this.user.specialty}`).then(res => {
      this.resources = res.data
    })
  },
  computed: {
    ...mapGetters(['user']),
    filteredPlatinum() {
      return this.filteredimage('platinum')
    },
    filteredScientificSocieties() {
      return this.filteredimage('scientificSocieties')
    },
    showTitle() {
      return this.countImages(this.filteredScientificSocieties)
    }
  },
  methods: {
    filteredimage: function (separator) {
      return this.imageGroup.filter(image => {
        return (
          image.separator == separator &&
          image.specialty.includes(this.user.specialty)
        )
      })
    },
    countImages: function (arr) {
      return arr.length > 0
    }
  }
}
</script>

<style>
main {
  padding: 25px;
}
.flexbox-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
</style>
